import { render, staticRenderFns } from "./brandTendencySearch.vue?vue&type=template&id=3b243906&scoped=true&"
import script from "./brandTendencySearch.vue?vue&type=script&lang=js&"
export * from "./brandTendencySearch.vue?vue&type=script&lang=js&"
import style0 from "./brandTendencySearch.vue?vue&type=style&index=0&id=3b243906&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b243906",
  null
  
)

export default component.exports